import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_VOUCHER_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

// The voucher discount is usually paid out of the marketplace commission, so
// only the customer sees it: the provider's payout is the same with or without
// it. On 0% commission listings the provider pays for it, and the line item is
// included for the provider too, so they see it as well.
const LineItemVoucherDiscountMaybe = props => {
  const { lineItems, isCustomer, intl } = props;
  const role = isCustomer ? 'customer' : 'provider';

  const voucherLineItem = lineItems.find(
    item =>
      item.code === LINE_ITEM_VOUCHER_DISCOUNT &&
      !item.reversal &&
      (item.includeFor || []).includes(role)
  );

  return voucherLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.voucherDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, voucherLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemVoucherDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemVoucherDiscountMaybe;
